'use client';

import { memo } from 'react';

import { usePremiereImportLifecycle } from '~/hooks/usePremiereImportLifecycle';

/** Mounts {@link usePremiereImportLifecycle} once at workspace layout level. */
export const PremiereImportLifecycle = memo(() => {
  usePremiereImportLifecycle();

  return null;
});

PremiereImportLifecycle.displayName = 'PremiereImportLifecycle';
